import Container from '~/components/Container';
import ProductRelated from '~/components/ProductRelated';
import { PATH, RelatedPosition } from '~/constants/enum';

type Props = {
    sku?: string;
    cartId?: string;
    data?: any[];
    parentSlug?: string;
    firstRelated?: any;
    relatedTopProducts?: any[];
    isMobile?: boolean;
};

const RelatedTop = ({ sku, data, parentSlug, firstRelated, relatedTopProducts, isMobile = false }: Props) => {
    // if (!data?.length) return;

    return (
        <Container className="flex flex-col gap-4">
            {data?.map((item: any, index: number) => {
                const firstBlockId = item.group_id === firstRelated?.group_id;
                return (
                    <ProductRelated
                        sku={sku}
                        ruleId={item.group_id}
                        limit={item.max_products}
                        title={item.block_title || item.name}
                        directLabel={firstBlockId === item.group_id && !!parentSlug ? 'View more' : undefined}
                        position={RelatedPosition.ProductContentTop}
                        directUrl={
                            firstBlockId === item.group_id && !!parentSlug
                                ? (PATH.ProductSimilarDetail.replace('[slug]', parentSlug) as string)
                                : undefined
                        }
                        relatedTopProduct={relatedTopProducts?.find(p => p?.relatedProductsByRule?.id === item.group_id)}
                        isMobile={isMobile}
                    />
                );
            })}
        </Container>
    );
};

export default RelatedTop;
